// Identidade da loja na aba do navegador: favicon (logo da empresa) e título da página.
// A logo vem de GET /companies/{code} (logoUrl). Para a aba não ficar sem ícone até a API
// responder, a última logo/nome ficam em cache no localStorage (chave escopada por empresa,
// descartada ao trocar REACT_APP_COMPANY_CODE — ver config/company.js).

export const BRANDING_STORAGE_KEY = "bonfim_company_branding";

/** Lê { name, logoUrl } salvos na última visita (ou null) */
export const getCachedBranding = () => {
  try {
    return JSON.parse(localStorage.getItem(BRANDING_STORAGE_KEY)) || null;
  } catch (e) {
    return null;
  }
};

const saveBranding = (branding) => {
  try {
    localStorage.setItem(BRANDING_STORAGE_KEY, JSON.stringify(branding));
  } catch (e) {
    // localStorage indisponível (modo privado): segue sem cache
  }
};

/** Cria/atualiza um <link rel="..."> no <head> */
const setHeadLink = (rel, href) => {
  let link = document.head.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
};

/**
 * Aplica favicon + título. Campos ausentes são ignorados (mantém o que já está na página).
 * @param {{ name?: string, logoUrl?: string }} branding
 * @param {{ persist?: boolean }} options - persist=true salva no cache para a próxima visita
 */
export const applyBranding = ({ name, logoUrl } = {}, { persist = false } = {}) => {
  if (logoUrl) {
    setHeadLink("icon", logoUrl);
    setHeadLink("apple-touch-icon", logoUrl);
  }
  if (name) {
    document.title = `${name} | Cardápio online`;
  }
  if (persist && (name || logoUrl)) {
    saveBranding({ name: name || null, logoUrl: logoUrl || null });
  }
};
